const t = {}
t.hometab = "HOME"
t.aboutUstab = "ABOUT US"
t.featuretab = "FEATURE"
t.contacttab = "CONTACT US"
t.learnMore = 'Learn more';
t.aboutUs = 'About Us';
t.tellUs = "Tell Us"
t.contactUs = "Contact Us"
t.transparency = "Digitization"
t.standardization = "Standardization"
t.informatization = "Informatization"
t.ingapore = "Singapore（HQ）"
t.china = "China"
t.greece = "Greece"
t.tel = "Tel"
t.email = "Email"
t.name = "Name"

t.home = {};
t.home.title = 'One Stop Marine Service Provider';
t.home.titleSecondaryTitle = 'We are servicing all coastal areas in China and Singapore.';

t.home.content1Title = 'Who We Are, What We Do?';
t.home.content1SecondaryTitle = 'ONE STOP MARINE SERVICE PROVIDER';
t.home.content1P1 = "We, as EMSOL Marine, a One Stop marine services provider in China and Singapore."
t.home.content1P2 = " We do full range of marine supplies, such as ship stores, provisions and bonded stores etc.  "
t.home.content1P3 = "We also provide warehouse storage and logistics with customs clearance for spare parts in transit and deliver to vessels. "
t.home.content1P4 = "We are 24/7/365 response, aim for quality products and high efficiencies on the services."

t.home.content2Title = "The Principles"
t.home.content2SecondaryTitle = "WE HAVE ALWAYS MAINTAINED OUR ORIGINAL ASPIRATION"
t.home.major = "Professional"
t.home.innovate = "Innovation"
t.home.collaborate = "Cooperation"
t.home.content2P1 = "We devote most of our time with professional team to provide the better services"
t.home.content2P2 = 'Keeps pace with the times, and create the future'
t.home.content2P3 = "Work together and win in cooperation"

t.home.content3Title = "The Products And Services We Offer"
t.home.content4SecondaryTitle = "WE CARE, YOU CAN REST ASSURED WITH THE SERVICES WE ARE PROVIDING"
t.home.newShip = "Initial Supply"
t.home.material = "Stores Supply"
t.home.food = "Food Supply"
t.home.consumables = "Consumables"
t.home.content3P1 = "We have a professional team， and expertise to assist our customers along with our quality products and high efficiency services. "
t.home.content3P2 = 'Through our extensive supplier network, we provide our customers with the quality supplies within both China and Singapore. Our goal is to ensure to our customers satisfaction. '
t.home.content3P3 = "We offer our customers a comprehensive range of fresh, frozen, chilled and dried foods to meet the diverse preferences from the vessel needs. We comply with the international food safety standards requirements."
t.home.content3P4 = "EMSOL is committed to provide first-class service and quality products with competitive prices."
t.home.footerTitle = "How can we help you?"

t.aboutus = {};
t.aboutus.titleSecondaryTitle = "We are servicing all coastal areas in China and Singapore."

t.aboutus.content1title = "Our honor"
t.aboutus.content1SecondaryTitle = "Adhering to the spirit of craftsman, and hard working for better"
t.aboutus.content1SecondaryTitle2 = "We are qualified with ISO9001: 2015, 14001: 2015 and ISO45001: 2018 standard. "

t.aboutus.content3title = "The EMSOL Team"
t.aboutus.content3SecondaryTitle = "TEAM EXECUTIVES"
t.aboutus.content3P1 = "We have creative team work, learn from each other, work together and devote most of time for a merely goal is that how we can service our customer."

t.feature = {};
t.feature.title = "We Are Just Getting Started.";
t.feature.titleSecondaryTitle = "In partnership with our clients, we are determined to create a positive economic and social impact – achieving our mission of shaping the chandlery world."

t.feature.title1 = "Moving Ahead Into The Future";
t.feature.titleSecondaryTitle1 = "We are setting out our future with the latest and up to date technologies. Combining our industry experience with our professional attitude to develop and deliver the most efficient and flexible operations management system for total."

t.feature.title2 = "Ongoing Project";
t.feature.titleSecondaryTitle2 = "We have been working hard to provide you with the most intimate service."

t.feature.title3 = "ERP System";
t.feature.titleSecondaryTitle3 = "We have smart ERP system to support EMSOL group digitally. Our idea is that how to make this business easy and to simple the operation."

t.feature.title4 = "Have An Idea That We Should Consider?";
t.feature.titleSecondaryTitle4 = "Get in touch, even if you are not a client, yet."

t.contact = {}

t.aboutus.titleSecondaryTitleB = "We are servicing all coastal areas in China and Singapore."
t.contact.title = "Moving Ahead Into The Future"
t.contact.titleSecondaryTitle = "We are setting out our future with the latest and up to date technologies. Combining our industry experience with our professional attitude to develop and deliver the most efficient and flexible operations management system for total,"
t.contact.title1 = "Where We Are"
t.contact.titleSecondaryTitle1 = "We have，at this moment 4 offices in China and Singapore, which is Nantong, Zhoushan and Lianyungang in China as Singapore. Our services covering from the South to the North for whole of major ports in China as well Singapore."

t.contact.title2 = "Singapore Office"
t.contact.addess1 = "60 Paya Lebar Road #04-12,Paya Lebar Square,Singapore 409051e"

t.contact.title3 = "Nan Tong Office"
t.contact.addess2 = "288 Yong Fu Road, Gangzha District,216002 Nan Tong City,Jiangsu Province, PRC."
t.contact.title4 = "Zhou Shan Office "
t.contact.addess3 = "199 Xingang ave, #W1-26,Dinghai district, 316013,Zhoushan City, Zhejiang,Province, PRC."
t.contact.title5 = "Lian Yun Gang Office "
t.contact.addess4 = "1 Dong Fang Road, #B3-3,222000 Lianyungang City,Jiangsu Province, PRC."
t.contact.title6 = "Greece Representative"



export default t
